import styled from "styled-components";

export const CollectionsOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
